import { render } from "./CardAcceptedBrands.vue?vue&type=template&id=1a40191a&scoped=true"
const script = {}

import "./CardAcceptedBrands.vue?vue&type=style&index=0&id=1a40191a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a40191a"]])

export default __exports__